import { Component, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (modalService.isOpen()) {
      <div 
        class="modal-backdrop"
        (click)="modalService.close()">
        <div 
          class="modal-content"
          [style.max-width]="modalService.maxWidth()"
          (click)="$event.stopPropagation()">
          <ng-container *ngTemplateOutlet="modalService.modalTemplate()"></ng-container>
        </div>
      </div>
    }
  `,
  styles: [`
    .modal-backdrop {
      position: fixed !important;
      inset: 0 !important;
      z-index: 999999 !important;
      background-color: rgba(0, 0, 0, 0.5) !important;
      backdrop-filter: blur(4px) !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 1rem !important;
      overflow-y: auto !important;
      pointer-events: all !important;
    }

    .modal-content {
      position: relative !important;
      width: 100% !important;
      max-height: 90vh !important;
      margin: auto 0 !important;
      overflow-y: auto !important;
      background: transparent !important;
      border-radius: 0 !important;
      box-shadow: none !important;
    }
  `]
})
export class Modal implements OnDestroy {
  modalService = inject(ModalService);

  ngOnDestroy() {
    // Ensure body scroll is restored
    document.body.style.overflow = '';
  }
}
